<template>
  <div>
    <el-dialog :title="$t('merchant.merchant_app_detail')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" width="900px" @close="initData">
      <div>
        <el-descriptions class="margin-top" :column="1" size="medium" border>
          <el-descriptions-item :content-style="textStyle" :label="$t('merchant.merchant_name')">
            {{ mchApp.merchant && mchApp.merchant.merchant_name }}

          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.notice_webhook')">
            {{ mchApp.notice_webhook }}
          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.callback_event_list')">
            <template v-if="mchApp.app_events && mchApp.app_events.length>0">
              <el-tag
                v-for="(even, index) in mchApp.app_events"
                :key="index"
                style="margin: 5px"
              >
                {{ even.event_name }}
              </el-tag>
            </template>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.qrcode_webhook')">
            {{ mchApp.qrcode_webhook }}
          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.transfer_webhook')">
            {{ mchApp.transfer_webhook }}
          </el-descriptions-item>

          <!--          <el-descriptions-item :label="$t('merchant.collect_url')">-->
          <!--            {{mchApp.collect_url}}-->
          <!--          </el-descriptions-item>-->

          <!--          <el-descriptions-item :label="$t('merchant.validate_url')">-->
          <!--            {{mchApp.validate_url}}-->
          <!--          </el-descriptions-item>-->

          <el-descriptions-item :label="$t('merchant.secret_key')">
            <div v-if="hiddenSecretKeyFlag">
              <div class="secret-content-left">
                <span>******</span>
              </div>
              <div class="secret-content-right">
                <div v-if="!showGetSecretMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-button size="small" type="primary" @click="changeSecretMsgCodeFlag">{{ $t('components.edit') }}</el-button>
                </div>
                <div v-if="showGetSecretMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-form ref="secretForm" :model="secretForm" label-position="right" :rules="rules" label-width="120px" class="demo-form">
                    <el-form-item label="email:" prop="email" required>
                      <el-input v-model="secretForm.email" disabled />
                    </el-form-item>
                    <el-form-item :label="$t('system.mfa_verify_code') + ':'" prop="msg_code">
                      <el-input v-model="secretForm.msg_code" :placeholder="$t('system.mfa_verify_code')" clearable />
                    </el-form-item>
                    <el-form-item style="text-align: center">
                      <el-button size="small" type="primary" style="width: 150px" @click="submitSecretDetail('secretForm')">{{ $t('components.confirm') }}</el-button>
                      <!--                      <el-button size="small" type="primary" :disabled="secretSecondFlag" @click="submitReSendCode('secretForm')">-->
                      <!--                        <span v-if="secretSecond === 60">{{ $t('components.send') }}</span>-->
                      <!--                        <span v-if="secretSecond < 60">{{ $t('components.re_send') }}</span>-->
                      <!--                        <span v-if="secretSecond < 60">({{ secretSecond }} S)</span>-->
                      <!--                      </el-button>-->
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="secret-content-left">
                <span>{{ mchApp.secret }}</span>
              </div>
              <div class="secret-content-right">
                <el-button size="small" type="primary" :disabled="reSetSecretFlag" @click="submitReSetSecret">{{ $t('components.clear') }}</el-button>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.public_key')">
            <div v-if="hiddenSecretKeyFlag">
              <div class="secret-content-left">
                <span>******</span>
              </div>
              <div class="secret-content-right" style="display: none">
                <div v-if="!showGetPublicMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-button size="small" type="primary" @click="changePublicMsgCodeFlag">{{ $t('components.edit') }}</el-button>
                </div>
                <div v-if="showGetPublicMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-form ref="publicForm" :model="publicForm" label-position="right" :rules="rules" label-width="80px" class="demo-form">
                    <el-form-item label="mobile:" prop="mobile" required>
                      <el-input v-model="publicForm.mobile" disabled />
                    </el-form-item>
                    <el-form-item label="code:" prop="msg_code">
                      <el-input v-model="publicForm.msg_code" />
                    </el-form-item>
                    <el-form-item style="text-align: center">
                      <el-button size="small" type="primary" @click="submitSecretDetail('publicForm')">{{ $t('components.confirm') }}</el-button>
                      <el-button size="small" type="primary" :disabled="publicKeySecondFlag" @click="submitReSendCode('publicForm')">
                        <span v-if="publicKeySecond === 60">{{ $t('components.send') }}</span>
                        <span v-if="publicKeySecond < 60">{{ $t('components.re_send') }}</span>
                        <span v-if="publicKeySecond<60">({{ publicKeySecond }} S)</span>
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <span v-if="!showPublicKeyInputFlag">{{ mchApp.public_key }}</span>
                <el-input
                  v-else
                  v-model="mchApp.public_key"
                  type="textarea"
                  :rows="6"
                  clearable
                />
              </div>
              <div>
                <el-button v-if="!showPublicKeyInputFlag" style="marginTop:10px;" size="small" type="primary" @click="switchPublicKeyInputFlag">{{ $t('components.modify') }}</el-button>
                <el-button v-else style="marginTop:10px;" size="small" type="primary" :disabled="reSetPublicSecretFlag" @click="submitReSetPublicSecret">{{ $t('components.confirm') }}</el-button>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item :label="$t('merchant.white_ips')+' '+$t('merchant.ips_tips')">
            <div v-if="hiddenSecretKeyFlag">
              <div class="secret-content-left">
                <span>******</span>
              </div>
              <div class="secret-content-right" style="display: none">
                <div v-if="!showGetWhiteIpsMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-button size="small" type="primary" @click="changeWhiteIpsMsgCodeFlag">{{ $t('components.edit') }}</el-button>
                </div>
                <div v-if="showGetWhiteIpsMsgCodeFlag && hiddenSecretKeyFlag">
                  <el-form ref="whiteIpsForm" :model="whiteIpsForm" label-position="right" :rules="rules" label-width="80px" class="demo-form">
                    <el-form-item label="mobile:" prop="mobile" required>
                      <el-input v-model="whiteIpsForm.mobile" disabled />
                    </el-form-item>
                    <el-form-item label="code:" prop="msg_code">
                      <el-input v-model="whiteIpsForm.msg_code" />
                    </el-form-item>
                    <el-form-item style="text-align: center">
                      <el-button size="small" type="primary" @click="submitSecretDetail('whiteIpsForm')">{{ $t('components.confirm') }}</el-button>
                      <el-button size="small" type="primary" :disabled="whiteIpsSecondFlag" @click="submitReSendCode('whiteIpsForm')">
                        <span v-if="whiteIpsSecond === 60">{{ $t('components.send') }}</span>
                        <span v-if="whiteIpsSecond < 60">{{ $t('components.re_send') }}</span>
                        <span v-if="whiteIpsSecond<60">({{ whiteIpsSecond }} S)</span>
                      </el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <span v-if="!showWhiteIpsInputFlag">{{ mchApp.white_ips }}</span>
                <el-input
                  v-else
                  v-model="mchApp.white_ips"
                  clearable
                />
              </div>
              <div>
                <el-button v-if="!showWhiteIpsInputFlag" style="marginTop:10px;" size="small" type="primary" @click="switchWhiteIpsInputFlag">{{ $t('components.modify') }}</el-button>
                <el-button v-else size="small" type="primary" :disabled="reSetWhiteIpsFlag" style="marginTop:10px;" @click="submitReSetWhiteIps">{{ $t('components.confirm') }}</el-button>
              </div>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchEventList, fetchMchAppSecretKey, reSetSecret, reSetPublicSecret, reSetMchAppWhiteIps } from '@/api/merchant-manage/merchant-manage'
import { sendSecrtKeySms, sendSecrtKeyEmail } from '@/api/application/application'
import { validateMobile } from '@/utils/validate'
import { cryptoJSAesEncrypt, cryptoJSAesDecrypt } from '@/utils/encrypt'
import { setLocalStorageKeyVal, getLocalStorageVal, removeLocalStorageVal } from '@/utils/helper'

const secret_second = 'secret_second'

export default {
  name: 'MerchantAppModal',

  data() {
    const checkNumberType = (rule, value, callback) => {
      if (value !== '0' && !Number(value)) {
        return callback(new Error('legal_person_mobile only can input number'))
      }
      return callback()
    }
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    return {
      textStyle: { 'width': '700px' },
      dialogUserVisible: false,
      eventList: [],
      mchApp: {
        id: '',
        secret: '',
        public_key: '',
        white_ips: ''
      },
      secretForm: { appId: '', email: cryptoJSAesDecrypt(this.$store.getters.legalEmail), msg_code: '' },
      publicForm: { id: '', email: '', msg_code: '' },
      whiteIpsForm: { id: '', email: '', msg_code: '' },
      rules: {
        mobile: [
          { validator: checkNumberType, trigger: ['blur', 'change'] },
          { pattern: validateMobile(), message: 'Pls input the correct phone num and start with 01' }
        ],
        msg_code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      },
      hiddenSecretKeyFlag: true,
      showGetSecretMsgCodeFlag: false,
      showGetPublicMsgCodeFlag: false,
      showGetWhiteIpsMsgCodeFlag: false,
      reSetSecretFlag: false,
      reSetPublicSecretFlag: false,
      reSetWhiteIpsFlag: false,
      showPublicKeyInputFlag: false,
      showWhiteIpsInputFlag: false,
      secretSecond: 60,
      publicKeySecond: 60,
      whiteIpsSecond: 60,
      secretSecondFlag: false,
      publicKeySecondFlag: false,
      whiteIpsSecondFlag: false
    }
  },
  created() {
    this.getEventList()
  },
  mounted() {
    this.secretSecond = getLocalStorageVal(secret_second)
    if (this.secretSecond < 60) {
      this.secretSecondFlag = true
      this.secretInterval()
    }
    this.$bus.off('SHOW_MERCHANT_APP_DETAIL_MODAL')
    this.$bus.on('SHOW_MERCHANT_APP_DETAIL_MODAL', (value) => {
      this.dialogUserVisible = value[0]
      this.mchApp = { ...this.mchApp, ...value[1] }
      this.secretForm.appId = value[1].appkey
      this.publicForm.id = value[1].id
      this.whiteIpsForm.id = value[1].id
    })
  },
  methods: {
    initData() {
      this.mchApp = {}
      this.secretForm = { id: '', email: cryptoJSAesDecrypt(this.$store.getters.legalEmail), msg_code: '' }
      this.publicForm = { id: '', email: '', msg_code: '' }
      this.whiteIpsForm = { id: '', email: '', msg_code: '' }
      this.hiddenSecretKeyFlag = true
      this.showGetSecretMsgCodeFlag = false
      this.showGetPublicMsgCodeFlag = false
      this.showGetWhiteIpsMsgCodeFlag = false
    },
    getEventList() {
      fetchEventList().then(res => {
        if (res.code === 10000) {
          this.eventList = res.data
        }
      })
    },
    changeSecretMsgCodeFlag() {
      this.showGetSecretMsgCodeFlag = true
    },
    changePublicMsgCodeFlag() {
      this.showGetPublicMsgCodeFlag = true
    },
    changeWhiteIpsMsgCodeFlag() {
      this.showGetWhiteIpsMsgCodeFlag = true
    },
    submitSecretDetail(formName) {
      let params = {}
      if (formName === 'secretForm') {
        params.appId = this.secretForm.appId
        // params.email = cryptoJSAesEncrypt(this.secretForm.email)
        params.msg_code = this.secretForm.msg_code
      } else if (formName === 'publicForm') {
        params = this.publicForm
      } else {
        params = this.whiteIpsForm
      }

      // 清楚校验提示
      this.$refs[formName].clearValidate()
      // 添加短信验证码校验
      this.rules.msg_code = [{ validator: this.validateMsgCode, trigger: 'blur' }]

      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetchMchAppSecretKey(params).then(res => {
            if (res.code === 10000) {
              this.$message.success('Success')
              this.mchApp.secret = res.data.secret
              this.mchApp.public_key = res.data.public_key
              this.mchApp.white_ips = res.data.white_ips
              this.hiddenSecretKeyFlag = false
            }
          })
        }
      })
    },
    validateMsgCode(rule, value, callback) {
      if (!value || value === '') {
        return callback(new Error('msg_code is required'))
      }
      return callback()
    },

    submitReSendCode(formName) {
      const params = {}
      if (formName === 'secretForm') {
        // params.email =  cryptoJSAesEncrypt(this.secretForm.email)
      } else if (formName === 'publicForm') {
        // params.email = this.publicForm.email
      } else {
        // params.email = this.whiteIpsForm.email
      }
      // 清除校验提示
      this.$refs[formName].clearValidate()
      // 清除短信验证码校验
      this.rules.msg_code = []

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendEmail(params)
          this.setReSendInterval(formName)
        }
      })
    },
    sendSms(params) {
      sendSecrtKeySms(params).then(res => {
        if (res.code === 10000) {
        }
      })
    },
    sendEmail(params) {
      sendSecrtKeyEmail().then(res => {
        if (res.code === 10000) {
          const remain_num = res.data.remain_num
          this.$message.success(`Successful! And you can send verification code for ${remain_num} times`)
        }
      })
    },
    setReSendInterval(formName) {
      if (formName === 'secretForm') {
        this.secretInterval()
      } else if (formName === 'publicForm') {
        this.publicKeyInterval()
      } else {
        this.whiteIpsInterval()
      }
    },
    secretInterval() {
      const that = this

      const secretInterval = setInterval(function() {
        that.secretSecondFlag = true
        that.secretSecond--
        setLocalStorageKeyVal(secret_second, that.secretSecond)
        if (that.secretSecond <= 0) {
          that.secretSecondFlag = false
          that.secretSecond = 60
          removeLocalStorageVal(secret_second)
          clearInterval(secretInterval)
        }
      }, 1000)
    },
    publicKeyInterval() {
      this.publicKeySecond = 60
      const that = this

      const publicInterval = setInterval(function() {
        that.publicKeySecondFlag = true
        that.publicKeySecond--
        if (that.publicKeySecond <= 0) {
          that.publicKeySecondFlag = false
          that.publicKeySecond = 60
          clearInterval(publicInterval)
        }
      }, 1000)
    },
    whiteIpsInterval() {
      this.whiteIpsSecond = 60
      const that = this

      const whiteIpsInterval = setInterval(function() {
        that.whiteIpsSecondFlag = true
        that.whiteIpsSecond--
        if (that.whiteIpsSecond <= 0) {
          that.whiteIpsSecond = false
          that.whiteIpsSecond = 60
          clearInterval(whiteIpsInterval)
        }
      }, 1000)
    },
    submitReSetSecret() {
      this.$confirm('Did you want to re-set Secret Key?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.reSetSecretFlag = true
        const params = { id: this.mchApp.appkey }

        reSetSecret(params).then(res => {
          if (res.code === 10000) {
            this.$message.success('Success')
            this.mchApp.secret = res.data.secret
          }
        }).then(() => {
          this.reSetSecretFlag = false
        })
      })
    },
    switchPublicKeyInputFlag() {
      this.showPublicKeyInputFlag = true
    },
    switchWhiteIpsInputFlag() {
      this.showWhiteIpsInputFlag = true
    },
    submitReSetPublicSecret() {
      this.reSetPublicSecretFlag = true
      const params = {
        id: this.mchApp.appkey,
        public_key: this.mchApp.public_key
      }

      reSetPublicSecret(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.mchApp.public_key = res.data.public_key
          this.showPublicKeyInputFlag = false
        }
      }).then(() => {
        this.reSetPublicSecretFlag = false
      })
    },
    submitReSetWhiteIps() {
      this.reSetWhiteIpsFlag = true
      const params = {
        id: this.mchApp.appkey,
        white_ips: this.mchApp.white_ips
      }

      reSetMchAppWhiteIps(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.mchApp.white_ips = res.data.white_ips
          this.showWhiteIpsInputFlag = false
        }
      }).then(() => {
        this.reSetWhiteIpsFlag = false
      })
    }
  }
}
</script>

<style scoped>
  .secret-content-left {
    display: inline-block;
    width: 48%;
    text-align: left;
  }
  .secret-content-right {
    display: inline-block;
    width: 51%;
    text-align: right;
  }

</style>
